/**
 * Generated bundle index. Do not edit.
 */

export {BoldReportViewerModule,BoldReportDesignerModule,BoldReportsModule} from './index';

export {BoldReportComponents as ɵb} from './core';
export {BoldReportDesignerComponent as ɵc} from './reportdesigner.component';
export {BoldReportViewerComponent as ɵa} from './reportviewer.component';